import React, { useState } from 'react';
import { Wrapper } from './style';

const Backdrop = ({ isOpen, handleClick, closeOnClick, zIndex }) => {
  const [clicked, setClicked] = useState(false);
  const clickHandler = () => {
    if (handleClick) handleClick();
    if (closeOnClick) {
      setClicked(true);
    }
  };
  return <Wrapper zIndex={zIndex} isOpen={!clicked && isOpen} onClick={() => clickHandler()} />;
};

export default Backdrop;
